import React, {Component} from 'react'
import {UserAction} from '../actions/UserAction'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import SearchCard from "./SearchCard";
import Search from "./Search";
import {gaPageView} from "../constants";
import AdverseMediaCard from "./AdverseMediaCard";

class Console extends Component {

    componentDidMount() {
        gaPageView()
    }

    render() {

        return (
            <>
                <Search/>
                <SearchCard/>
                {/*<PortCard/>*/}
                <AdverseMediaCard/>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Console);